import { StyleSheet } from 'react-native';

import { Fonts } from '@vfgroup-oneplatform/foundation/Components/Themes';

export default StyleSheet.create({
  scrollViewContentContainerWithTray: {
    paddingBottom: 100,
  },
  sectionHeader: {
    marginHorizontal: 16,
    marginTop: 28,
  },
  addOnsListContainer: {
    paddingHorizontal: 16,
  },

  dividerContainer: {
    paddingHorizontal: 16,
    paddingVertical: 19,
  },
  divider: theme => ({
    height: 1.5,
    width: '100%',
    backgroundColor: theme.colors.dividerTwo,
    marginBottom: 10,
    paddingHorizontal: 16,
  }),
  errorContainer: {
    height: 'auto',
    marginTop: 40,
  },
  errorIcon: {
    marginTop: 0,
  },
  headerDescription: theme => ({
    fontSize: 16.6,
    color: theme.colors.subtitle,
    marginVertical: 17,
  }),
  noAddonsText: {
    fontSize: 17,
    alignSelf: 'center',
    width: '85%',
    textAlign: 'center',
    fontFamily: Fonts.type.VodafoneLt,
    lineHeight: 22,
    marginTop: 23,
  },
});
